module.exports = __webpack_public_path__ + "img/Physics.5a28ca39.png";